module.exports = __webpack_public_path__ + "img/noticebg-limit.d784ee4d.png";